/* ── Complemento del carrito (11/10/2026) ─────────────────────────────────
   El neceser que se ofrece encima de la protección (snippets/lirea-complemento.liquid).

   - Se agrega SIN recargar: /cart/add.js pide también el HTML de las secciones del
     carrito (Section Rendering API) y se repinta con window.lireaCartUI.refresh, el
     mismo camino que ya usa la protección. La tarjeta desaparece al repintar porque
     el Liquid ya ve el neceser dentro.
   - Un toque = una unidad: una sola escucha delegada en document (aunque el script
     se cargue dos veces en /cart) y un candado mientras hay una petición en curso.
   - El neceser no se vende solo: si en el carrito quedan únicamente complementos
     (neceser y/o protección), se vacía. La protección sola ya la limpia lirea.js.
   Los handles de los complementos los pinta el snippet en [data-lirea-complementos].
   Copia anterior: assets/lirea-complemento-ANTES-2026-10-12.js */
(function () {
  if (window.__lireaComplemento) return;
  window.__lireaComplemento = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var PROTECCION = 'proteccion-de-envio';
  var ocupado = false;
  var limpiando = false;

  function complementos() {
    var el = document.querySelector('[data-lirea-complementos]');
    var lista = el ? el.getAttribute('data-lirea-complementos') : PROTECCION + ',neceser-rosa';
    return lista.split(',').map(function (h) { return h.trim(); }).filter(Boolean);
  }

  function secciones() {
    return window.lireaCartUI ? window.lireaCartUI.sections() : ['cart-drawer', 'cart-icon-bubble'];
  }

  function repintar(estado) {
    return window.lireaCartUI ? window.lireaCartUI.refresh(estado) : Promise.resolve();
  }

  function leerJSON(r) {
    return r.json().then(function (d) {
      if (!r.ok || (d && d.status >= 400)) throw new Error((d && (d.description || d.message)) || 'cart');
      return d;
    });
  }

  /* ── Mientras se agrega, el resto del carrito espera ──
     El tema identifica las líneas por su posición. Si alguien toca la papelera o el +/−
     mientras entra el neceser, la posición ya no es la misma y se tocaría la línea
     equivocada. Durante esos instantes se ignoran esos toques (y se ve atenuado). */
  document.addEventListener('click', function (e) {
    if (!ocupado) return;
    var t = e.target && e.target.closest && e.target.closest(
      'cart-remove-button, .cart-remove-button, .quantity__button, .lirea-prot__caja, .lirea-prot__check'
    );
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }, true);

  function marcarOcupado(si) {
    ocupado = si;
    document.documentElement.classList.toggle('lirea-carrito-ocupado', si);
  }

  /* ── Agregar ── */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.lirea-complemento__btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (ocupado || btn.disabled) return;

    var id = Number(btn.getAttribute('data-variante'));
    if (!id) return;

    marcarOcupado(true);
    var caja = btn.closest('.lirea-complemento');
    var error = caja && caja.querySelector('.lirea-complemento__error');
    var etiqueta = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Agregando…';
    if (error) error.hidden = true;
    if (caja) caja.classList.add('lirea-complemento--cargando');

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: id, quantity: 1 }],
        sections: secciones(),
        sections_url: window.location.pathname
      })
    })
      .then(leerJSON)
      .then(repintar)
      .catch(function () {
        // Si el repintado ya sustituyó la tarjeta, estas referencias están fuera del DOM: no pasa nada.
        btn.disabled = false;
        btn.textContent = etiqueta;
        if (caja) caja.classList.remove('lirea-complemento--cargando');
        if (error) {
          error.textContent = 'No se pudo agregar. Probá de nuevo.';
          error.hidden = false;
        }
      })
      .finally(function () { marcarOcupado(false); });
  }, true);

  /* ── Quitar el último labial con el bolsito dentro (bug 12/10) ──
     Antes: el tema quitaba el labial, pintaba un carrito con solo el bolsito y, casi un
     segundo después, limpiar() lo vaciaba y volvía a pintar → parpadeo y espera.
     Ahora, si lo que se quita es el último producto principal, se vacía el carrito de una
     vez (una sola petición) y se pinta una sola vez, directamente vacío. */
  function esComplemento(fila, comps) {
    var a = fila.querySelector('a[href*="/products/"]');
    var m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return !!(m && comps.indexOf(m[1]) >= 0);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('cart-remove-button, .cart-remove-button');
    if (!btn || ocupado) return;
    var fila = btn.closest('.cart-item');
    var lista = fila && fila.parentElement;
    if (!fila || !lista) return;
    var comps = complementos();
    if (esComplemento(fila, comps)) return;               // quitar el bolsito: lo hace el tema
    var filas = Array.prototype.slice.call(lista.querySelectorAll('.cart-item'));
    var otrosPrincipales = filas.filter(function (f) { return f !== fila && !esComplemento(f, comps); });
    var hayComplementos = filas.some(function (f) { return esComplemento(f, comps); });
    if (otrosPrincipales.length || !hayComplementos) return; // caso normal: lo hace el tema

    e.preventDefault();
    e.stopImmediatePropagation();
    marcarOcupado(true);
    fetch(ROOT + 'cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ sections: secciones(), sections_url: window.location.pathname })
    })
      .then(leerJSON)
      .then(function (estado) {
        if (window.lireaCartUI) return repintar(estado);
        window.location.reload();
      })
      .catch(function () { window.location.reload(); })
      .finally(function () { marcarOcupado(false); });
  }, true);

  /* ── Carrito con solo complementos → vacío ── */
  function limpiar() {
    if (limpiando) return;
    limpiando = true;
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(leerJSON)
      .then(function (carrito) {
        if (!carrito || !carrito.items || !carrito.items.length) return;
        var comps = complementos();
        var soloComplementos = carrito.items.every(function (it) { return comps.indexOf(it.handle) >= 0; });
        var algoMasQueProteccion = carrito.items.some(function (it) { return it.handle !== PROTECCION; });
        if (!soloComplementos || !algoMasQueProteccion) return;
        return fetch(ROOT + 'cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ sections: secciones(), sections_url: window.location.pathname })
        })
          .then(leerJSON)
          .then(repintar);
      })
      .catch(function () { /* se reintenta en el siguiente cambio del carrito */ })
      .finally(function () { limpiando = false; });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', limpiar);
  else limpiar();

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(limpiar, 50); });
  }

  // Quitar un artículo repinta sin recargar; se vuelve a mirar después de ese clic.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('cart-remove-button, .cart-remove-button, [id^="Remove-"]')) {
      setTimeout(limpiar, 900);
    }
  }, true);

  // Volver atrás con el navegador (página restaurada de caché): el carrito pintado puede ser viejo.
  // Ojo: sin cabecera Accept JSON; en una ficha de producto devolvería el JSON del producto.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted || !window.lireaCartUI) return;
    fetch(window.location.pathname + '?sections=' + secciones().join(','))
      .then(function (r) { if (!r.ok) throw new Error('sections'); return r.json(); })
      .then(function (html) { return repintar({ sections: html }); })
      .then(limpiar, limpiar);
  });

  /* ── En el cajón, la tarjeta va DEBAJO de los productos (zona con scroll) ──
     El Liquid la pinta en el pie, junto a la protección. En el cajón ese pie es fijo y,
     con poca altura de pantalla, le quitaba sitio a la lista hasta tapar el labial.
     Aquí se mueve justo debajo de la lista. En /cart no se toca: allí el pie no es fijo.

     Bug 12/10 (arreglado): el tema tiene DOS formas de repintar el cajón.
       a) Entero (agregar desde la ficha, el propio bolsito, la protección): el pie trae
          la tarjeta nueva, o ninguna si ya no toca. Eso manda.
       b) Solo la lista (assets/cart.js → onCartUpdate, p. ej. al agregar un segundo pack):
          sustituye <cart-drawer-items> y NO el pie. Como la tarjeta ya se había movido a la
          lista, desaparecía. Ahora se vuelve a poner la última al instante y se confirma
          con el carrito real (una petición ligera) por si ya no tocaba. */
  var ultimaTarjeta = null;
  var ultimaMarca = null;
  var verificando = false;

  function insertar(tarjeta, destino) {
    var lista = destino.querySelector('.drawer__cart-items-wrapper');
    tarjeta.classList.add('lirea-complemento--cajon');
    if (lista) lista.insertAdjacentElement('afterend', tarjeta);
    else destino.appendChild(tarjeta);
  }

  function verificar() {
    if (verificando) return;
    verificando = true;
    fetch(ROOT + '?sections=cart-drawer')
      .then(function (r) { if (!r.ok) throw new Error('sections'); return r.json(); })
      .then(function (json) {
        var html = new DOMParser().parseFromString(json['cart-drawer'] || '', 'text/html');
        var fresca = html.querySelector('.drawer__footer .lirea-complemento');
        var cajon = document.querySelector('cart-drawer');
        var destino = cajon && cajon.querySelector('#CartDrawer-CartItems');
        if (!destino) return;
        var actual = destino.querySelector('.lirea-complemento');
        if (!fresca || !destino.querySelector('.cart-item')) {
          if (actual) actual.remove();
          ultimaTarjeta = null;
          return;
        }
        fresca = document.importNode(fresca, true);
        if (actual) actual.replaceWith(fresca); else insertar(fresca, destino);
        fresca.classList.add('lirea-complemento--cajon');
        ultimaTarjeta = fresca;
      })
      .catch(function () { /* se queda la que hay */ })
      .finally(function () { verificando = false; });
  }

  function colocar() {
    var cajon = document.querySelector('cart-drawer');
    if (!cajon) return;
    var destino = cajon.querySelector('#CartDrawer-CartItems');
    if (!destino) return;
    var marca = cajon.querySelector('.drawer__footer [data-lirea-complementos]');
    var enPie = cajon.querySelector('.drawer__footer .lirea-complemento');
    var enLista = destino.querySelector('.lirea-complemento');

    if (marca !== ultimaMarca) {
      // a) Repintado entero: lo que diga el pie es la verdad.
      ultimaMarca = marca;
      if (enLista && enLista !== enPie) enLista.remove();
      if (enPie) { insertar(enPie, destino); ultimaTarjeta = enPie; }
      else ultimaTarjeta = null;
      return;
    }

    if (enPie) { insertar(enPie, destino); ultimaTarjeta = enPie; return; }

    // b) Solo se repintó la lista: si había tarjeta y sigue habiendo productos, se repone ya.
    if (!enLista && ultimaTarjeta && destino.querySelector('.cart-item')) {
      insertar(ultimaTarjeta, destino);
      verificar();
    }
  }

  function vigilarCajon() {
    var cajon = document.querySelector('cart-drawer');
    if (!cajon || !window.MutationObserver) return;
    colocar();
    new MutationObserver(colocar).observe(cajon, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vigilarCajon);
  else vigilarCajon();
})();
